var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"value":_vm.value,"color":"#FF6700","border":"left","icon":"$fasExclamationTriangle","outlined":"","text":"","dismissible":_vm.dismissable},on:{"input":_vm.onInput}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }